import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import './style.scss'

const blogPost = [
    {
        title: 'IMSSPIRA ASESORÍA Y GESTIÓN INTEGRAL S.A. DE C.V.',
        text: '1. Identidad y Domicilio del Responsable:\n' +
            'IMSSPIRA ASESORÍA Y GESTIÓN INTEGRAL S.A. de C.V., con domicilio en Calle Nicolas Romero No. 1555 int. 5-A, Colonia Niños Héroes, en el Municipio de Guadalajara, Jalisco, C.P. 44260, es responsable del tratamiento de los datos personales que nos proporcione.\n' +
            ' \n' +
            '2. Datos Personales Recabados y Finalidades del Tratamiento\n' +
            'Recabamos los siguientes datos personales:\n' +
            '• Datos de identificación: Nombre completo.\n' +
            '• Datos de contacto: Número(s) telefónico(s), correo electrónico.\n' +
            '• Datos laborales/profesionales: Número de Seguridad Social (NSS), RFC, CURP.\n' +
            '• Referencias personales: Nombres y datos de contacto de personas de referencia\n' +
            'Las finalidades del tratamiento son:\n' +
            '• Finalidades Primarias (Necesarias para la relación jurídica):\n' +
            '•  Realizar las gestiones y trámites burocráticos solicitados por usted (pensiones, seguros de desempleo, registros institucionales, etc.).\n' +
            '•  Cumplir con las obligaciones legales y contractuales derivadas de los servicios contratados.\n' +
            '•  Contactarle para seguimiento de sus trámites y gestiones.\n' +
            '•  Integrar y mantener actualizado su expediente.\n' +
            '• Finalidades Secundarias (No necesarias para la relación jurídica):\n' +
            '•  Envío de información sobre nuevos servicios o promociones.\n' +
            '•  Realización de encuestas de satisfacción.\n' +
            '•  Invitaciones a eventos relacionados con nuestros servicios.\n' +
            'Usted puede manifestar su negativa al tratamiento para las finalidades secundarias en el momento de proporcionar sus datos o posteriormente mediante el procedimiento establecido en este aviso.\n' +
            ' \n' +
            '3. Transferencias de Datos Personales\n' +
            'Sus datos personales podrán ser transferidos y tratados dentro y fuera del país por personas distintas a esta empresa, exclusivamente para las finalidades primarias antes señaladas, como:\n' +
            '• Instituciones públicas ante las cuales se realizan los trámites (IMSS, INFONAVIT, Secretaría del Trabajo, etc.).\n' +
            '• Autoridades gubernamentales, cuando exista un requerimiento legal o judicial.\n' +
            '• Proveedores de servicios necesarios para la gestión (ej. mensajería, sistemas informáticos), quienes estarán obligados a mantener la confidencialidad.\n' +
            'No se realizarán transferencias para fines mercadotécnicos, publicitarios o de prospección comercial sin su consentimiento expreso.\n' +
            ' \n' +
            ' \n' +
            ' \n' +
            '4. Medios para Ejercer los Derechos ARCO y de Revocación del Consentimiento\n' +
            'Usted tiene derecho a:\n' +
            '• Acceder a sus datos personales que poseemos y a los detalles de su tratamiento.\n' +
            '• Rectificar sus datos si son inexactos o incompletos.\n' +
            '• Cancelar el uso de sus datos cuando considere que no se requieren para alguna de las finalidades señaladas, estén siendo utilizados para fines no consentidos o haya finalizado la relación de servicios.\n' +
            '• Oponerse al tratamiento de sus datos para fines específicos (oposición).\n' +
            'Para ejercer cualquiera de estos Derechos ARCO, o para revocar el consentimiento otorgado para el tratamiento de sus datos, debe presentar una solicitud mediante:\n' +
            '• Correo electrónico a: imsspira.tramites@gmail.com\n' +
            '• Escrito presentado en nuestro domicilio.\n' +
            'La solicitud deberá contener: a) Su nombre completo y datos de contacto; b) Documentos que acrediten su identidad (copia de INE) y, en su caso, la representación legal; c) Descripción clara y precisa de los datos respecto de los cuales busca ejercer algún derecho; d) Cualquier otro elemento o documento que facilite la localización de sus datos.\n' +
            'Responderemos a su solicitud en un plazo máximo de 20 días hábiles desde su recepción. La respuesta se comunicará al correo electrónico que designe en la solicitud.\n' +
            'Conservaremos sus datos personales durante el tiempo necesario para cumplir con las finalidades descritas y las obligaciones legales derivadas de nuestra relación, y posteriormente por un plazo de 1 (uno) año para atender posibles responsabilidades jurídicas.\n' +
            ' \n' +
            '5. Medidas de Seguridad Para el manejo de la Información Sensible\n' +
            'Implementamos y mantenemos medidas de seguridad administrativas, técnicas y físicas, proporcionales a la sensibilidad de los datos que tratamos, destinadas a proteger sus datos personales contra daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no autorizados, de acuerdo con lo establecido en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n' +
            ' \n' +
            '6. Uso de Tecnologías de Rastreo\n' +
            'Le informamos que nuestra página de internet utiliza cookies y tecnologías de rastreo para mejorar su experiencia de usuario y con fines estadísticos. Los datos personales que recaban estas tecnologías no se utilizan para identificarle personalmente.\n' +
            ' \n' +
            '7. Cambios al Aviso de Privacidad\n' +
            'Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones al presente aviso, derivadas de cambios en nuestra legislación, políticas internas o nuevos requerimientos para la prestación de nuestros servicios. Le notificaremos cualquier cambio mediante: publicación en nuestro sitio web, comunicación por correo electrónico o por escrito en nuestro domicilio.\n' +
            ' \n' +
            ' \n' +
            '8. Consentimiento\n' +
            'Al proporcionar sus datos personales, por cualquier medio (formulario físico, correo electrónico, sitio web), manifiesta haber leído, entendido y aceptado los términos de este Aviso de Privacidad, otorgando su consentimiento para el tratamiento de sus datos conforme a las finalidades primarias descritas. Para las finalidades secundarias, su consentimiento se considerará otorgado si no manifiesta su oposición.\n'
    },
    {
        title: 'Fecha de última actualización: 02 de enero de 2026',
        isEmail: true,
    }
];

const ContentPrivacyPolicy = () => {
    return (
        <Fragment>
            {blogPost.map((blog, i) => (
                <div key={i} className="blogPostWrapper">
                    <div className="blogPostContent">
                        <h4>{blog.title}</h4>

                        {blog.bullets ? (
                            <ul>
                                {blog.bullets.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>
                        ) : blog.isEmail ? (
                            <p>
                                Si tienes algunas duda sobre la politica de privacidad, porfavor contactanos<br />
                                Imsspira Team<br />
                                <a href="mailto:imsspira.tramites@gmail.com">imsspira.tramites@gmail.com</a><br />
                            </p>
                        ) : (
                            blog.text?.split('\n').map((para, idx) => (
                                <p key={idx}>{para}</p>
                            ))
                        )}
                    </div>
                </div>
            ))}
        </Fragment>
    );
};

export default ContentPrivacyPolicy;
